/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Projects_Wizard_Loading_TitleInputs */



/**
* | output |
* | --- |
* | "Linking projects…" |
*
* @param {Linked_Projects_Wizard_Loading_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const linked_projects_wizard_loading_title = /** @type {((inputs?: Linked_Projects_Wizard_Loading_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Projects_Wizard_Loading_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekte werden verknüpft…")
	return /** @type {LocalizedString} */ ("Linking projects…")
});